import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import copy from 'clipboard-copy';
import { useRouter } from 'next/router';
import { debounce } from '@mui/material/utils';
import { alpha, styled } from '@mui/material/styles';
import { Tabs } from '@mui/base/Tabs';
import { TabPanel } from '@mui/base/TabPanel';
import { unstable_useId as useId } from '@mui/utils';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import NoSsr from '@mui/material/NoSsr';
import { HighlightedCode } from '@mui/docs/HighlightedCode';
import { CodeTab, CodeTabList } from '@mui/docs/HighlightedCodeWithTabs';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import LibraryAddCheckRoundedIcon from '@mui/icons-material/LibraryAddCheckRounded';
import DemoSandbox from 'docs/src/modules/components/DemoSandbox';
import ReactRunner from 'docs/src/modules/components/ReactRunner';
import DemoEditor from 'docs/src/modules/components/DemoEditor';
import DemoEditorError from 'docs/src/modules/components/DemoEditorError';
import { pathnameToLanguage } from 'docs/src/modules/utils/helpers';
import { useCodeVariant } from 'docs/src/modules/utils/codeVariant';
import { CODE_VARIANTS } from 'docs/src/modules/constants';
import { useUserLanguage, useTranslate } from '@mui/docs/i18n';
import stylingSolutionMapping from 'docs/src/modules/utils/stylingSolutionMapping';
import DemoToolbarRoot from 'docs/src/modules/components/DemoToolbarRoot';
import { AdCarbonInline } from '@mui/docs/Ad';
import DemoAiSuggestionHero from 'docs/src/modules/components/DemoAiSuggestionHero';

/**
 * Removes leading spaces (indentation) present in the `.tsx` previews
 * to be able to replace the existing code with the incoming dynamic code
 * @param {string} input
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function trimLeadingSpaces() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return input.replace(/^\s+/gm, '');
}
var DemoToolbar = /*#__PURE__*/React.lazy(function () {
  return import('./DemoToolbar');
});
function DemoToolbarFallback() {
  var t = useTranslate();

  // Sync with styles from DemoToolbar, we can't import the styles
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      height: 42
    },
    "aria-busy": true,
    "aria-label": t('demoToolbarLabel'),
    role: "toolbar"
  });
}
function getDemoName(location) {
  return location.endsWith('.js') || location.endsWith('.tsx') ? location.replace(/(.+?)(\w+)\.\w+$$/, '$2') :
  // the demos with multiple styling solution point to directory
  location.split('/').pop();
}
function useDemoData(codeVariant, demo, githubLocation) {
  var userLanguage = useUserLanguage();
  var router = useRouter();
  var _pathnameToLanguage = pathnameToLanguage(router.asPath),
    canonicalAs = _pathnameToLanguage.canonicalAs;
  return React.useMemo(function () {
    var productId;
    var name = 'Material UI';
    if (canonicalAs.startsWith('/joy-ui/')) {
      productId = 'joy-ui';
      name = 'Joy UI';
    } else if (canonicalAs.startsWith('/x/')) {
      name = 'MUI X';
    }
    var codeOptions = {};
    if (codeVariant === CODE_VARIANTS.TS && demo.rawTS) {
      var _demo$tsx;
      codeOptions = {
        codeVariant: CODE_VARIANTS.TS,
        githubLocation: githubLocation.replace(/\.js$/, '.tsx'),
        raw: demo.rawTS,
        module: demo.moduleTS,
        Component: (_demo$tsx = demo.tsx) != null ? _demo$tsx : null,
        sourceLanguage: 'tsx'
      };
      if (demo.relativeModules) {
        codeOptions.relativeModules = demo.relativeModules[CODE_VARIANTS.TS];
      }
    } else {
      codeOptions = {
        codeVariant: CODE_VARIANTS.JS,
        githubLocation: githubLocation,
        raw: demo.raw,
        module: demo.module,
        Component: demo.js,
        sourceLanguage: 'jsx'
      };
      if (demo.relativeModules) {
        codeOptions.relativeModules = demo.relativeModules[CODE_VARIANTS.JS];
      }
    }
    return _extends({
      scope: demo.scope,
      jsxPreview: demo.jsxPreview
    }, codeOptions, {
      title: "".concat(getDemoName(githubLocation), " demo \u2014 ").concat(name),
      productId: productId,
      language: userLanguage
    });
  }, [canonicalAs, codeVariant, demo, githubLocation, userLanguage]);
}
function useDemoElement(_ref) {
  var demoData = _ref.demoData,
    editorCode = _ref.editorCode,
    setDebouncedError = _ref.setDebouncedError,
    liveDemoActive = _ref.liveDemoActive;
  var debouncedSetError = React.useMemo(function () {
    return debounce(setDebouncedError, 300);
  }, [setDebouncedError]);
  React.useEffect(function () {
    return function () {
      debouncedSetError.clear();
    };
  }, [debouncedSetError]);

  // Memoize to avoid rendering the demo more than it needs to be.
  // For example, avoid a render when the demo is hovered.
  var BundledComponent = React.useMemo(function () {
    return /*#__PURE__*/_jsx(demoData.Component, {});
  }, [demoData]);
  var LiveComponent = React.useMemo(function () {
    return /*#__PURE__*/_jsx(ReactRunner, {
      scope: demoData.scope,
      onError: debouncedSetError,
      code: editorCode.isPreview ? trimLeadingSpaces(demoData.raw).replace(trimLeadingSpaces(demoData.jsxPreview), editorCode.value) : editorCode.value
    });
  }, [demoData, debouncedSetError, editorCode.isPreview, editorCode.value]);

  // No need for a live environment if the code matches with the component rendered server-side.
  return editorCode.value === editorCode.initialEditorCode && liveDemoActive === false ? BundledComponent : LiveComponent;
}
var Root = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty({
    marginBottom: 24,
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2)
  }, theme.breakpoints.up('sm'), {
    marginLeft: 0,
    marginRight: 0
  });
});
var DemoRoot = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hideToolbar' && prop !== 'bg' && prop !== 'hasAiSuggestion';
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: 'relative',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    variants: [{
      props: function props(_ref5) {
        var hideToolbar = _ref5.hideToolbar;
        return hideToolbar;
      },
      style: _defineProperty({}, theme.breakpoints.up('sm'), {
        borderRadius: 12
      })
    }, {
      props: function props(_ref6) {
        var hideToolbar = _ref6.hideToolbar;
        return !hideToolbar;
      },
      style: _defineProperty({}, theme.breakpoints.up('sm'), {
        borderRadius: '12px 12px 0 0'
      })
    }, {
      props: {
        bg: 'outlined'
      },
      style: _defineProperty({}, theme.breakpoints.up('sm'), {
        borderLeftWidth: 1,
        borderRightWidth: 1
      })
    }, {
      props: {
        bg: 'inline'
      },
      style: _defineProperty({}, theme.breakpoints.up('sm'), {
        padding: theme.spacing(0)
      })
    }, {
      props: {
        bg: 'gradient'
      },
      style: _defineProperty({}, theme.breakpoints.up('sm'), {
        padding: theme.spacing(12, 8),
        borderLeftWidth: 1,
        borderRightWidth: 1
      })
    }, {
      props: {
        bg: 'outlined'
      },
      style: _extends({
        padding: theme.spacing(3),
        backgroundColor: (theme.vars || theme).palette.background.paper,
        border: "1px solid ".concat((theme.vars || theme).palette.divider),
        borderLeftWidth: 0,
        borderRightWidth: 0
      }, theme.applyDarkStyles({
        backgroundColor: alpha(theme.palette.primaryDark[700], 0.1)
      }))
    }, {
      props: {
        bg: 'playground'
      },
      style: {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        border: "1px solid ".concat((theme.vars || theme).palette.divider),
        overflow: 'auto'
      }
    }, {
      props: {
        bg: true
      },
      style: _extends({
        padding: theme.spacing(3),
        backgroundColor: alpha(theme.palette.grey[50], 0.5),
        border: "1px solid ".concat((theme.vars || theme).palette.divider)
      }, theme.applyDarkStyles({
        backgroundColor: alpha(theme.palette.primaryDark[700], 0.4)
      }))
    }, {
      props: {
        bg: 'gradient'
      },
      style: _extends({
        overflow: 'auto',
        padding: theme.spacing(4, 2),
        border: "1px solid ".concat((theme.vars || theme).palette.divider),
        borderLeftWidth: 0,
        borderRightWidth: 0,
        backgroundClip: 'padding-box',
        backgroundColor: alpha(theme.palette.primary[50], 0.2),
        backgroundImage: "radial-gradient(120% 140% at 50% 10%, transparent 40%, ".concat(alpha(theme.palette.primary[100], 0.2), " 70%)")
      }, theme.applyDarkStyles({
        backgroundColor: (theme.vars || theme).palette.primaryDark[900],
        backgroundImage: "radial-gradient(120% 140% at 50% 10%, transparent 30%, ".concat(alpha(theme.palette.primary[900], 0.3), " 80%)")
      }))
    }]
  };
});
var DemoCodeViewer = styled(HighlightedCode)(function () {
  return {
    '& pre': {
      margin: 0,
      marginTop: -1,
      maxHeight: 'min(68vh, 1000px)',
      maxWidth: 'initial',
      borderRadius: 0,
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12
    }
  };
});
var AnchorLink = styled('div')({
  marginTop: -64,
  // height of toolbar
  position: 'absolute'
});
var InitialFocus = styled(IconButton)(function (_ref7) {
  var theme = _ref7.theme;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: theme.spacing(4),
    height: theme.spacing(4),
    pointerEvents: 'none'
  };
});
var selectionOverride = function selectionOverride(theme) {
  return {
    cursor: 'pointer',
    '&.base--selected': _extends({
      color: (theme.vars || theme).palette.primary[700],
      backgroundColor: (theme.vars || theme).palette.primary[50],
      borderColor: (theme.vars || theme).palette.primary[200]
    }, theme.applyDarkStyles({
      color: (theme.vars || theme).palette.primary[200],
      backgroundColor: alpha(theme.palette.primary[900], 0.4),
      borderColor: (theme.vars || theme).palette.primary[800]
    }))
  };
};
export default function Demo(props) {
  var _demo$relativeModules, _demo$relativeModules2;
  var demo = props.demo,
    demoOptions = props.demoOptions,
    disableAd = props.disableAd,
    githubLocation = props.githubLocation;
  if (false) {
    if (demoOptions.hideToolbar === false) {
      throw new Error(['"hideToolbar": false is already the default.', "Please remove the property in {{\"demo\": \"".concat(demoOptions.demo, "\", \u2026}}.")].join('\n'));
    }
    if (demoOptions.hideToolbar === true && demoOptions.defaultCodeOpen === true) {
      throw new Error(['"hideToolbar": true, "defaultCodeOpen": true combination is invalid.', "Please remove one of the properties in {{\"demo\": \"".concat(demoOptions.demo, "\", \u2026}}.")].join('\n'));
    }
    if (demoOptions.hideToolbar === true && demoOptions.disableAd === true) {
      throw new Error(['"hideToolbar": true, "disableAd": true combination is invalid.', "Please remove one of the properties in {{\"demo\": \"".concat(demoOptions.demo, "\", \u2026}}.")].join('\n'));
    }
  }
  if ((demoOptions.demo.endsWith('.ts') || demoOptions.demo.endsWith('.tsx')) && demoOptions.hideToolbar !== true) {
    throw new Error(["The following demos use TS directly: ".concat(demoOptions.demo, "."), '', 'Please run "pnpm docs:typescript:formatted" to generate a JS version and reference it:', // This regex intentionally excludes the dot character in the Kleene star to prevent ReDoS
    // See https://github.com/mui/material-ui/issues/44078
    "{{\"demo\": \"".concat(demoOptions.demo.replace(/\.([^.]*)$/, '.js'), "\", \u2026}}."), '', "Otherwise, if it's not a code demo hide the toolbar:", "{{\"demo\": \"".concat(demoOptions.demo, "\", \"hideToolbar\": true, \u2026}}.")].join('\n'));
  }
  var t = useTranslate();
  var codeVariant = useCodeVariant();
  var demoData = useDemoData(codeVariant, demo, githubLocation);
  var hasNonSystemDemos = demo.rawTailwind || demo.rawTailwindTS || demo.rawCSS || demo.rawCSSTs;
  var demoName = getDemoName(demoData.githubLocation);
  var demoSandboxedStyle = React.useMemo(function () {
    return {
      maxWidth: demoOptions.maxWidth,
      height: demoOptions.height
    };
  }, [demoOptions.height, demoOptions.maxWidth]);
  if (demoOptions.bg == null) {
    demoOptions.bg = 'outlined';
    if (demoOptions.iframe) {
      demoOptions.bg = true;
    }
  }
  var _React$useState = React.useState(demoOptions.defaultCodeOpen || false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    codeOpen = _React$useState2[0],
    setCodeOpen = _React$useState2[1];
  var shownOnce = React.useRef(false);
  if (codeOpen) {
    shownOnce.current = true;
  }
  React.useEffect(function () {
    var navigatedDemoName = getDemoName(window.location.hash);
    if (navigatedDemoName && demoName === navigatedDemoName) {
      setCodeOpen(true);
    }
  }, [demoName]);
  var showPreview = !demoOptions.hideToolbar && demoOptions.defaultCodeOpen !== false && Boolean(demoData.jsxPreview);
  var _React$useReducer = React.useReducer(function (key) {
      return key + 1;
    }, 0),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    demoKey = _React$useReducer2[0],
    setDemoKey = _React$useReducer2[1];
  var demoId = "demo-".concat(useId());
  var demoSourceId = "demoSource-".concat(useId());
  var openDemoSource = codeOpen || showPreview;
  var initialFocusRef = React.useRef(null);
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    showAd = _React$useState4[0],
    setShowAd = _React$useState4[1];
  var adVisibility = showAd && !disableAd && !demoOptions.disableAd;
  var isPreview = !codeOpen && showPreview;
  var initialEditorCode = isPreview ? demoData.jsxPreview :
  // Prettier remove all the leading lines except for the last one, remove it as we don't
  // need it in the live edit view.
  demoData.raw.replace(/\n$/, '');
  var _React$useState5 = React.useState({
      value: initialEditorCode,
      isPreview: isPreview,
      initialEditorCode: initialEditorCode
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    editorCode = _React$useState6[0],
    setEditorCode = _React$useState6[1];
  var resetDemo = React.useMemo(function () {
    return function () {
      setEditorCode({
        value: initialEditorCode,
        isPreview: isPreview,
        initialEditorCode: initialEditorCode
      });
      setDemoKey();
    };
  }, [setEditorCode, setDemoKey, initialEditorCode, isPreview]);
  React.useEffect(function () {
    setEditorCode({
      value: initialEditorCode,
      isPreview: isPreview,
      initialEditorCode: initialEditorCode
    });
  }, [initialEditorCode, isPreview]);
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    debouncedError = _React$useState8[0],
    setDebouncedError = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    liveDemoActive = _React$useState10[0],
    setLiveDemoActive = _React$useState10[1];
  var demoElement = useDemoElement({
    demoData: demoData,
    editorCode: editorCode,
    setDebouncedError: setDebouncedError,
    liveDemoActive: liveDemoActive
  });
  var _React$useState11 = React.useState(0),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    activeTab = _React$useState12[0],
    setActiveTab = _React$useState12[1];
  var handleTabChange = function handleTabChange(event, newValue) {
    setActiveTab(newValue);
  };
  var ownerState = {
    mounted: true,
    contained: true
  };
  var tabs = React.useMemo(function () {
    if (!demoData.relativeModules) {
      return [{
        module: demoData.module,
        raw: demoData.raw
      }];
    }
    var demoModule = demoData.module;
    if (codeVariant === CODE_VARIANTS.TS && demo.moduleTS) {
      demoModule = demo.moduleTS === demo.module ? demoData.module.replace(/\.js$/, '.tsx') : demo.moduleTS;
    }
    return [{
      module: demoModule,
      raw: demoData.raw
    }].concat(_toConsumableArray(demoData.relativeModules));
  }, [codeVariant, demo.moduleTS, demo.module, demoData.module, demoData.raw, demoData.relativeModules]);
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    copiedContent = _React$useState14[0],
    setCopiedContent = _React$useState14[1];
  var handleCopyClick = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var activeTabData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            activeTabData = tabs[activeTab];
            _context.next = 4;
            return copy(activeTabData.raw);
          case 4:
            setCopiedContent(true);
            setTimeout(function () {
              setCopiedContent(false);
            }, 1000);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error('Code content not copied', _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function handleCopyClick() {
      return _ref8.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs(Root, {
    children: [/*#__PURE__*/_jsx(AnchorLink, {
      id: demoName
    }), /*#__PURE__*/_jsxs(DemoRoot, {
      hideToolbar: demoOptions.hideToolbar,
      bg: demoOptions.bg,
      id: demoId,
      hasAiSuggestion: Boolean(demoOptions.aiSuggestion),
      children: [/*#__PURE__*/_jsx(InitialFocus, {
        "aria-label": t('initialFocusLabel'),
        action: initialFocusRef,
        tabIndex: -1
      }), /*#__PURE__*/_jsx(DemoSandbox, {
        id: demoId,
        style: demoSandboxedStyle,
        iframe: demoOptions.iframe,
        isolated: demoOptions.isolated,
        isJoy: demoData.productId === 'joy-ui',
        name: demoName,
        onResetDemoClick: resetDemo,
        children: demoElement
      }, demoKey)]
    }), demoOptions.hideToolbar ? null : /*#__PURE__*/_jsxs(React.Fragment, {
      children: [Object.keys(stylingSolutionMapping).map(function (key) {
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(AnchorLink, {
            id: "".concat(stylingSolutionMapping[key], "-").concat(demoName, ".js")
          }), /*#__PURE__*/_jsx(AnchorLink, {
            id: "".concat(stylingSolutionMapping[key], "-").concat(demoName, ".tsx")
          })]
        }, key);
      }), /*#__PURE__*/_jsx(AnchorLink, {
        id: "".concat(demoName, ".js")
      }), /*#__PURE__*/_jsx(AnchorLink, {
        id: "".concat(demoName, ".tsx")
      }), /*#__PURE__*/_jsx(DemoToolbarRoot, {
        demoOptions: demoOptions,
        openDemoSource: openDemoSource,
        children: /*#__PURE__*/_jsx(NoSsr, {
          fallback: /*#__PURE__*/_jsx(DemoToolbarFallback, {}),
          children: /*#__PURE__*/_jsx(React.Suspense, {
            fallback: /*#__PURE__*/_jsx(DemoToolbarFallback, {}),
            children: /*#__PURE__*/_jsx(DemoToolbar, {
              codeOpen: codeOpen,
              codeVariant: codeVariant,
              copyIcon: copiedContent ? /*#__PURE__*/_jsx(LibraryAddCheckRoundedIcon, {}) : /*#__PURE__*/_jsx(ContentCopyRoundedIcon, {}),
              copyButtonOnClick: handleCopyClick,
              hasNonSystemDemos: hasNonSystemDemos,
              demo: demo,
              demoData: demoData,
              demoId: demoId,
              demoName: demoName,
              demoOptions: demoOptions,
              demoSourceId: demoSourceId,
              initialFocusRef: initialFocusRef,
              onCodeOpenChange: function onCodeOpenChange() {
                setCodeOpen(function (open) {
                  return !open;
                });
                setShowAd(true);
              },
              onResetDemoClick: resetDemo,
              openDemoSource: openDemoSource,
              showPreview: showPreview
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Tabs, {
        value: activeTab,
        onChange: handleTabChange,
        children: [demoData.relativeModules && openDemoSource && !editorCode.isPreview ? /*#__PURE__*/_jsx(CodeTabList, {
          ownerState: ownerState,
          children: tabs.map(function (tab, index) {
            return /*#__PURE__*/_jsx(CodeTab, {
              sx: selectionOverride,
              ownerState: ownerState,
              value: index,
              children: tab.module
            }, tab.module);
          })
        }) : null, /*#__PURE__*/_jsx(Collapse, {
          "in": openDemoSource,
          unmountOnExit: true,
          timeout: 150,
          children: tabs.map(function (tab, index) {
            return /*#__PURE__*/_jsx(TabPanel, {
              value: index,
              index: index,
              children: demoOptions.disableLiveEdit || index > 0 ? /*#__PURE__*/_jsx(DemoCodeViewer, {
                code: tab.raw,
                id: demoSourceId,
                language: demoData.sourceLanguage,
                copyButtonProps: {
                  'data-ga-event-category': codeOpen ? 'demo-expand' : 'demo',
                  'data-ga-event-label': demo.gaLabel,
                  'data-ga-event-action': 'copy-click'
                },
                sx: {
                  '& .MuiCode-copy': {
                    display: 'none'
                  },
                  '& pre': {
                    borderBottomLeftRadius: demoOptions.aiSuggestion ? 0 : 12,
                    borderBottomRightRadius: demoOptions.aiSuggestion ? 0 : 12
                  }
                }
              }, index) : /*#__PURE__*/_jsx(DemoEditor
              // Mount a new text editor when the preview mode change to reset the undo/redo history.
              , {
                value: editorCode.value,
                onChange: function onChange(value) {
                  setEditorCode(_extends({}, editorCode, {
                    value: value
                  }));
                },
                onFocus: function onFocus() {
                  setLiveDemoActive(true);
                },
                id: demoSourceId,
                language: demoData.sourceLanguage,
                copyButtonProps: {
                  'data-ga-event-category': codeOpen ? 'demo-expand' : 'demo',
                  'data-ga-event-label': demo.gaLabel,
                  'data-ga-event-action': 'copy-click'
                },
                sx: {
                  '& .scrollContainer': {
                    borderBottomLeftRadius: demoOptions.aiSuggestion ? 0 : 12,
                    borderBottomRightRadius: demoOptions.aiSuggestion ? 0 : 12
                  }
                },
                children: /*#__PURE__*/_jsx(DemoEditorError, {
                  children: debouncedError
                })
              }, editorCode.isPreview)
            }, index);
          })
        })]
      }), demoOptions.aiSuggestion ? /*#__PURE__*/_jsx(DemoAiSuggestionHero, {
        suggestion: demoOptions.aiSuggestion,
        params: {
          name: demoName,
          description: demoOptions.aiSuggestion,
          initialMessage: demoOptions.aiSuggestion,
          files: [{
            path: demo.moduleTS,
            content: demo.rawTS,
            isEntry: true
          }].concat(_toConsumableArray(((_demo$relativeModules = (_demo$relativeModules2 = demo.relativeModules) == null ? void 0 : _demo$relativeModules2.TS) != null ? _demo$relativeModules : []).map(function (module) {
            return {
              path: module.module,
              content: module.raw
            };
          })))
        }
      }) : null, adVisibility ? /*#__PURE__*/_jsx(AdCarbonInline, {}) : null]
    })]
  });
}
false ? void 0 : void 0;